import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { getLoggedinPartnersInfo } from "../api/pfs";
import type { IErrorType } from "../constants/apiconstants-hydra";
import type { IPartnerInfo } from "../constants/apiconstants-pfs";

export const partnerInfoQueryKey = ["partnerInfo"] as const;

type UsePartnerInfoOptions = {
	enabled?: boolean;
	includeTechPartnerOnBoarding?: boolean;
};

export const usePartnerInfo = (options: UsePartnerInfoOptions = {}): UseQueryResult<IPartnerInfo, IErrorType> => {
	const { enabled = true, includeTechPartnerOnBoarding = true } = options;

	return useQuery<IPartnerInfo, IErrorType>({
		queryKey: partnerInfoQueryKey,
		queryFn: async ({ signal }): Promise<IPartnerInfo> => getLoggedinPartnersInfo(includeTechPartnerOnBoarding, signal),
		enabled,
	});
};
